import React from 'react'; 
import { connect } from 'react-redux'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { LoadingComponent } from '../../utils/ui'
import { WikiActions, Linker } from '../../redux';
import WikiSelectPage from '../../components/wiki/WikiSelectPage';
import { makeURL } from '../../components/wiki/helper';
import { WIKI } from '../../const/C';
/**
 * Спциальный объект, проксирующие выбор wiki статей.
 * Основная задача - загрузить необходимые данные и после из загрузки отобразить выбор wiki статей
 */
class WikiProxy extends React.Component {
  //dispatch(WikiActions.loadNodes());
  state = {
    loaded: false, 			  //Флаг загрузки, необходимый данных
  }


  static getDerivedStateFromProps(props, state) {
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    this.loadWikiNodes()
  }

  loadWikiNodes() {
    this.setState({loaded: false})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание
      this.props.onLoadNodes(),
    ])
    .then ((response) =>{
      this.setState({loaded: true, error: undefined});
    })
    .catch(e => { 
      this.setState({loaded: true, error: e});
    });
  }

  onSelected (selectedKeys, info) {
    //Проверим, что это статья (есть title)
    if (info.node.props.dataRef.title)
      return this.props.onSelect(this.props.nodes, info);
  }

  render() {
    console.log(this);
    let { loaded } = this.state;
    if (!loaded) return <LoadingComponent />;
    return (
      <WikiSelectPage onSelect={(selectedKeys, info) => this.onSelected(selectedKeys, info)}/>
    )
  }
}

//Представление информации о Wiki статьях
export default connect(
  (state, props) => {
    const { vset, lwiki} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      selected: lwiki.page,
      nodes: (lwiki.page) ? lwiki.nodes.filter(item => item.nodeId==lwiki.page.nodeId) : [],
    })
  },
  dispatch => ({
    onSelect (nodes, info)  {
      //console.log('WikiProxy.js onSelect (nodes, info)', nodes, info);
      const label = (info.node.props.dataRef.title)?info.node.props.dataRef.title:info.node.props.dataRef.name;
      return dispatch(Linker.SELECTED(WIKI.PREDICAT, makeURL(nodes, info.node.props.dataRef), label))
    },
  
    onLoadDetailWikies (actions, values){
      return dispatch(actions.LOAD_WIKIES(values));
    },
    onLoadNodes(){
      return dispatch(WikiActions.loadNodes());
    },
  })
)(WikiProxy)

